import axios from 'axios';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

export function useRequest() {
  const token = cookies.get('token');
  const [loading, setLoading] = useState(false);
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log("error", error);
      if (error.response?.status === 401) {
        window.location = '/unauthorized';
      }
      if (error.response?.status === 404) {
        window.location = '/notFound';
      }
      if (error.response?.status === 500) {
        window.location = '/internalServer';
      } else {
        if (typeof error.response.data.errors == 'string') {
          toast.error(error.response.data.errors, {
            autoClose: false
          });
          return error;
        } else {
          Object.values(error.response.data.errors).forEach((val) => {
            toast.error(val[0]);
          });
          return error;
        }
      }
    }
  );
  const apiUrl = process.env.REACT_APP_API_ENDPOINT;

  axios.defaults.baseURL = apiUrl;

  const request = useCallback(async (url, options = {}) => {
    if (token) {
      options.headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
      };
      options.data = options.data ? options.data : { ...options.body };
      try {
        setLoading(true);
        const response = await axios(url, options);
        return response;
      } catch (error) {
        return error;
      } finally {
        setLoading(false);
      }
     } 
    //else {
    //   window.location.reload();
    // }
  }, []);
  return { request, loading };
}
